const videos = {
    portugues: {
        msgNotLive1: 'Ansioso? Calma!',
        msgNotLive2: 'Em breve tem Live',
        msgNotLive3: 'Clique aqui para acessar nossa página inicial',        
        msgLive1: '<strong>Hoje é dia de transmissão do ensaio ao vivo no Bella da Semana</strong>',        
        msgLive2: 'Acompanhe em tempo real os bastidores deste maravilhoso ensaio, sem censura, completo, mostrando tudo que nós gostamos de ver.',
        msgLive3: '<strong>Os vídeos ficarão disponíveis para assistir durante 48 horas - após este período serão expirados.</strong>',
        msgLive4: 'Lembrando que uma Live inédita em 4K, com cenas exclusivas e muito mais closes será lançada juntamente como ensaio, para você se deliciar nos mínimos detalhes.',
        msgLive5: 'Clique no <strong>PLAY</strong> abaixo e assista a Live. Caso o vídeo não seja exibido, clique em "reload" (recarregar a página) ou pressione F5.',
    },
    ingles: {
        msgNotLive1: 'Anxious? Relax!',
        msgNotLive2: 'A Live is coming soon',
        msgNotLive3: 'Click here to access our home page',
        msgLive1: '<strong>Today is live shooting broadcast day at Bella Club</strong>',
        msgLive2: 'Follow in real time behind the scenes of this wonderful photo shoot, uncensored, complete, showing everything we like to see.',
        msgLive3: '<strong>The videos will be available to watch for 48 hours - after this period they will expire.</strong>',
        msgLive4: 'Remembering that an unprecedented Live in 4K, with exclusive scenes and much more close-ups will be released together as a shooting, for you to delight in the smallest details.',
        msgLive5: 'Click <strong>PLAY</strong> below and watch the Live. If the video is not displayed, click on "reload" (reload the page) or press F5.',
    }
  }
  
  export default videos
  